import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { fontFamily } from "@mui/system";

const Navbar = ({}) => {
  const userId = localStorage.getItem("UserId");
  const name = localStorage.getItem("Name");
  const email = localStorage.getItem("Email");
  
  return (
    <>
      {!userId ? (
        <>
          <nav
            className="navbar navbar-expand-lg navbar-light fixed"
            style={{ backgroundColor: "transparent" }}
          >
            <div className="container justify-content-center">
              <div className="d-flex align-items-center  justify-content-between">
                <div
                  className="nnavbar-brand fw-bold fs-3 text-dark"
                  style={{ fontFamily: "comfortaa" }}
                >
                  Report AI
                </div>
              </div>
            </div>
          </nav>
          <hr
            style={{
              width: userId ? "100%" : "40%",
              margin: "0 auto",
              border: "1px solid gray",
            }}
          />
        </>
      ) : (
        <nav
          className="navbar navbar-expand-lg navbar-dark fixed-top"
          style={{ backgroundColor: "#EEEEEE", borderRadius: "5px" }}
        >
          <div className="container d-flex justify-content-between align-items-center">
            {/* Left: Report AI Title */}
            <div
              className="navbar-brand fw-bold fs-3 text-dark"
              style={{ fontFamily: "Comfortaa" }}
            >
              Report AI
            </div>

            {/* Right: Profile Element */}
            <div className="d-flex align-items-center">
              <div className="text-end me-3">
                <div className="fw-bold">{name}</div>
                <div className="text-muted">{email}</div>
                {/* Designation */}
              </div>
              <i class="bi bi-person-circle h1"></i>
            </div>
          </div>
        </nav>
      )}
    </>
  );
};

export default Navbar;
